export class DealerShip {
    list: Array<ItemDealerShip> = [];
    constructor (client,id) {
        this.list.push({client:client,id:id});
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/dealer-ship.ts